import { observable, set } from 'mobx';
import { IItemTypeahead } from '../../interfaces/ISearchInterfaces';

export class SearchTypeaheadCatalog {
    @observable public dimensionsTypeahead: IItemTypeahead[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any) {
        const searchTypeaheadCatalog = new SearchTypeaheadCatalog();
        set(searchTypeaheadCatalog, data);

        return searchTypeaheadCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.dimensionsTypeahead = [];
        data.map((items: IItemTypeahead[]) => {
            items.map((item: IItemTypeahead) => {
                this.dimensionsTypeahead.push(item);
            });
        });
    };
}
